import styled from 'styled-components';

export const ChartContainer = styled.div`
  position: relative;
  height: ${(props) => (typeof props.height === 'number' ? `${props.height}px` : props.height || '300px')};
  width: 100%;
`;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Chart/components/ChartStyles.js